/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Info_Batch_Selected_CountInputs */



/**
* | output |
* | --- |
* | "{count} projects selected" |
*
* @param {Explorer_Info_Batch_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_selected_count = /** @type {((inputs: Explorer_Info_Batch_Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Projets ${i?.count} sélectionnés`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} ausgewählte Projekte`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Progetti selezionati ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`отобранные проекты ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Proyectos ${i?.count} seleccionados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已选择 ${i?.count} 项目`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} プロジェクトが選択されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चयनित परियोजनाएँ ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Projetos ${i?.count} selecionados`)
	return /** @type {LocalizedString} */ (`${i?.count} projects selected`)
});